import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";
import axiosInstance from "../../Shared/axiosInstance.js";

export default function تحديث_المورد() {
  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const navigate = useNavigate();
  const { id } = useParams();

  async function getSupplierById(supplierId) {
    try {
      const { data } = await axiosInstance.get(`/Supplier/${supplierId}`);
      return data?.data || null;
    } catch (error) {
      console.error("حدث خطأ أثناء جلب بيانات المورد:", error);
      Swal.fire({
        title: "خطأ!",
        text: "فشل تحميل بيانات المورد.",
        icon: "error",
      });
      navigate("/suppliers");
      return null;
    }
  }

  const formik = useFormik({
    initialValues: { id: "", name: "", phone: "", details: "" },
    validate: (values) => {
      const errors = {};
      setErrorMsg(null);

      if (!values.name.trim()) {
        errors.name = "الاسم مطلوب";
      } else if (values.name.length < 3) {
        errors.name = "الاسم يجب أن يكون 3 أحرف على الأقل";
      }

      if (!values.phone.trim()) {
        errors.phone = "رقم الهاتف مطلوب";
      } else if (!/^[0-9+\-\s()]+$/.test(values.phone)) {
        errors.phone = "يمكن أن يحتوي رقم الهاتف على أرقام و + - () فقط";
      } else if (values.phone.length > 40) {
        errors.phone = "رقم الهاتف طويل جدًا. الحد الأقصى 40 حرفًا";
      }

      if (!values.details.trim()) {
        errors.details = "التفاصيل مطلوبة";
      } else if (values.details.length < 5) {
        errors.details = "التفاصيل يجب أن تكون 5 أحرف على الأقل";
      }

      return errors;
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const supplierData = {
          id: values.id,
          name: values.name.trim(),
          phone: values.phone.trim(),
          details: values.details.trim(),
        };

        const { data } = await axiosInstance.put(
          `/Supplier/${id}`,
          supplierData
        );

        if (data?.status === 200) {
          await Swal.fire({
            title: "تم التحديث!",
            text: data.message || "تم تحديث المورد بنجاح",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          navigate("/suppliers");
        }
      } catch (error) {
        console.error("حدث خطأ أثناء تحديث المورد:", error);
        setErrorMsg(
          error?.response?.data?.message || "حدث خطأ ما"
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    async function loadData() {
      setIsLoadingData(true);
      const supplierData = await getSupplierById(id);
      if (supplierData) {
        formik.setValues({
          id: supplierData.id,
          name: supplierData.name || "",
          phone: supplierData.phone || "",
          details: supplierData.details || "",
        });
      }
      setIsLoadingData(false);
    }

    if (id) loadData();
  }, [id]);

  if (isLoadingData) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Bars height="80" width="80" color="#7c3aed" ariaLabel="loading" />
        <p style={{ marginTop: "20px", color: "#64748b", fontSize: "18px" }}>
          جارٍ تحميل بيانات المورد...
        </p>
      </div>
    );
  }

  return (
    <div
      style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: "40px", direction: "rtl" }}
    >
      <div className="container py-5" style={{ maxWidth: "700px" }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
          <div>
            <h2
              style={{
                color: "#7c3aed",
                fontWeight: "700",
                fontSize: "28px",
                marginBottom: "4px",
              }}
            >
              <i className="bi bi-truck me-2"></i>تحديث المورد
            </h2>
            <small style={{ color: "#64748b", fontSize: "14px" }}>
              تعديل بيانات المورد
            </small>
          </div>
          <button
            type="button"
            onClick={() => navigate("/suppliers")}
            style={{
              background: "#64748b",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              fontWeight: "600",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            <i className="bi bi-arrow-left me-1"></i> رجوع
          </button>
        </div>

        {/* Error Message */}
        {errorMsg && (
          <div
            style={{
              background: "#fee2e2",
              border: "1px solid #fecaca",
              color: "#991b1b",
              padding: "12px 16px",
              borderRadius: "8px",
              marginBottom: "20px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            <i className="bi bi-exclamation-triangle me-2"></i>
            {errorMsg}
          </div>
        )}

        {/* Form Card */}
        <div style={cardStyle}>
          <form onSubmit={formik.handleSubmit}>
            {/* Supplier Name */}
            <div className="mb-4">
              <label style={labelStyle}>
                <i className="bi bi-person-badge me-2"></i>اسم المورد *
              </label>
              <input
                type="text"
                name="name"
                placeholder="أدخل اسم المورد"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor:
                    formik.touched.name && formik.errors.name
                      ? "#dc2626"
                      : "#cbd5e1",
                }}
              />
              {formik.errors.name && formik.touched.name && (
                <div style={errorStyle}>
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {formik.errors.name}
                </div>
              )}
            </div>

            {/* Phone */}
            <div className="mb-4">
              <label style={labelStyle}>
                <i className="bi bi-telephone me-2"></i>رقم الهاتف *
              </label>
              <input
                type="text"
                name="phone"
                placeholder="أدخل رقم الهاتف"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor:
                    formik.touched.phone && formik.errors.phone
                      ? "#dc2626"
                      : "#cbd5e1",
                }}
              />
              {formik.errors.phone && formik.touched.phone && (
                <div style={errorStyle}>
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {formik.errors.phone}
                </div>
              )}
            </div>

            {/* Details */}
            <div className="mb-4">
              <label style={labelStyle}>
                <i className="bi bi-card-text me-2"></i>التفاصيل *
              </label>
              <textarea
                name="details"
                placeholder="أدخل تفاصيل المورد (العنوان، ملاحظات، إلخ)"
                rows="5"
                value={formik.values.details}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  resize: "vertical",
                  minHeight: "120px",
                  borderColor:
                    formik.touched.details && formik.errors.details
                      ? "#dc2626"
                      : "#cbd5e1",
                }}
              />
              {formik.errors.details && formik.touched.details && (
                <div style={errorStyle}>
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {formik.errors.details}
                </div>
              )}
              <small style={{ color: "#64748b", fontSize: "13px" }}>
                الحد الأدنى 5 أحرف
              </small>
            </div>

            {/* Action Buttons */}
            <div className="d-flex gap-3">
              <button
                type="submit"
                disabled={!(formik.dirty && formik.isValid) || isLoading}
                style={{
                  flex: 1,
                  background:
                    formik.dirty && formik.isValid && !isLoading
                      ? "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)"
                      : "#94a3b8",
                  color: "#fff",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "none",
                  fontWeight: "700",
                  fontSize: "18px",
                  cursor:
                    formik.dirty && formik.isValid && !isLoading
                      ? "pointer"
                      : "not-allowed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {isLoading ? (
                  <><Bars height="25" width="25" color="#fff" ariaLabel="loading" /> <span>جارٍ التحديث...</span></>
                ) : (
                  <><i className="bi bi-check-circle"></i> <span>تحديث المورد</span></>
                )}
              </button>

              <button
                type="button"
                onClick={() => navigate("/suppliers")}
                style={{
                  flex: 1,
                  background: "#fff",
                  color: "#475569",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "2px solid #cbd5e1",
                  fontWeight: "700",
                  fontSize: "18px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <i className="bi bi-x-circle"></i>
                <span>إلغاء</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Styles
const cardStyle = {
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  padding: "32px",
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
};

const labelStyle = {
  color: "#475569",
  fontSize: "15px",
  fontWeight: "600",
  marginBottom: "8px",
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "2px solid #cbd5e1",
  borderRadius: "8px",
  fontSize: "15px",
  color: "#1e293b",
  outline: "none",
  transition: "all 0.2s",
  fontWeight: "500",
};

const errorStyle = {
  color: "#dc2626",
  fontSize: "13px",
  marginTop: "6px",
  fontWeight: "600",
};
